import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import RH from '../../../components/rh/rh/cadastrar';


function CadRHScreen () {
    return (
        <Fragment>
            <Head titulo="Cadastro de RH | Consórcio LVF" />
            <Header />
            <RH />
            <Footer />
        </Fragment>
    );
}

export default CadRHScreen;